var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('form',{staticClass:"payment-result-form",attrs:{"id":"finalize"}},[_c('app-loaderForm',{ref:"LoaderForm",attrs:{"display":'block'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }